import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { MdDelete } from "react-icons/md";
import { TiDelete, TiPlus } from "react-icons/ti";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { getCurrentDate } from "../../../Utilitie";
import axios from "axios";
import Loading from "../../../Extra/Loading";

const ClsUnloadingIns = ({
  from,
  to,
  siding,
  rakeType,
  commodity,
  destination,
  backload,
  bpcic,
  bpcType,
  InterChange,
}) => {
  const [date, setDate] = useState(getCurrentDate());
  const createEntry = () => ({
    Sr_No: null,
    from: null,
    ldg_date: null,
    to: null,
    cmdt: null,
    act_wgn: null,
    wgn_type: null,
    tp_sp: null,
    to_interchange: null,
    to_date: null,
    to_time: null,
    status_remark: null,
    placed_date: null,
    placed_time: null,
    remarks: null,
    released_date: date,
    released_time: null,
    km_remaining: null,
    bpc_ic: null,
    bpc_date: null,
    bpc_type: null,
    sdg_depart_date: null,
    sdg_depart_time: null,
    rl_dp: null,
    load_name_loco_number: null,
    backloading: null,
    delete: null,
  });
  const TS = ["TP", "SP"];
  // const InterChange = ["NKJ", "MHDA"];

  const { userData } = useGlobalContext();
  const selectOptions = {
    wgn_type: rakeType,
    cmdt: commodity,
    tp_sp: TS,
    to: to,
    from: from,
    to_interchange: InterChange,
    bpc_ic: bpcic,
    bpc_type: bpcType,
  };
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [selectedRow, setSelectedRow] = useState(null);
  const [entries, setEntries] = useState([createEntry()]);
  const [updateData, setUpdateData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const keys = [
    "Sr No.",
    "from",
    "ldg_date",
    "to",
    "cmdt",
    "act_wgn",

    "wgn_type",
    "tp_sp",
    "to_interchange",
    "to_date",
    "to_time",
    "status_remark",
    "placed_date",
    "placed_time",
    "remarks",
    "released_date",
    "released_time",
    "km_remaining",
    "bpc_ic",
    "bpc_date",
    "bpc_type",
    "sdg_depart_date",
    "sdg_depart_time",
    "rl_dp",
    "load_name_loco_number",
    "backloading",
    "delete",
  ];
  const inputStyle = {
    width: "110px",
    background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const url = `${urlPrefix}getDynamicDataForTwoDate?table_name=t_unloading_hdr&released_date=${date}`;

      const response = await axios.get(url);

      if (response.data.success === true) {
        setUpdateData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, [date]);
  useEffect(() => {
    if (!updateData || !Array.isArray(updateData)) return;

    const formattedData = updateData.map((item) => ({
      ...item,
      isEdited: false,
    }));

    setEntries(formattedData);
  }, [updateData]);

  const getDiff = (rd, rt, dd, dt) => {
    if (!rd || !rt || !dd || !dt) return "";

    const diff = Math.abs(new Date(`${rd}T${rt}`) - new Date(`${dd}T${dt}`));

    const m = Math.floor(diff / 60000);

    return `${Math.floor(m / 60)}:${String(m % 60).padStart(2, "0")}`;
  };

  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) => {
        if (i !== rowIndex) return row;

        const updated = { ...row, [key]: value, isEdited: true };

        const rd = updated.released_date?.split("T")[0];
        const sd = updated.sdg_depart_date?.split("T")[0];

        return {
          ...updated,
          rl_dp:
            rd && updated.released_time && sd && updated.sdg_depart_time
              ? getDiff(rd, updated.released_time, sd, updated.sdg_depart_time)
              : "",
        };
      }),
    );
  };
  const addRow = () => {
    setEntries((prev) => [...prev, createEntry()]);
  };

  const removeRow = (index) => {
    setEntries((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    const editedRows = entries.filter((row) => row.isEdited);

    if (editedRows.length === 0) {
      toast.error("No changes found");
      return;
    }

    const updateRows = editedRows.filter((row) => row.id);

    const insertRows = editedRows.filter((row) => !row.id);

    const updatebklRows = editedRows.filter((row) => row.backloading);

    try {
      if (updateRows.length) {
        const updatePayload = {
          table_name: "t_unloading_hdr",
          rows: updateRows.map((entry) => ({
            id: entry.id,
            updates: {
              from: entry.from,
              ldg_date: entry.ldg_date?.slice(0, 10),
              to: entry.to,
              cmdt: entry.cmdt,
              act_wgn: entry.act_wgn,
              wgn_type: entry.wgn_type,
              tp_sp: entry.tp_sp,
              to_interchange: entry.to_interchange,
              to_date: entry.to_date?.slice(0, 10),
              to_time: entry.to_time,
              status_remark: entry.status_remark,
              placed_date: entry.placed_date?.slice(0, 10),
              placed_time: entry.placed_time,
              remarks: entry.remarks,
              released_date: entry.released_date?.slice(0, 10),
              released_time: entry.released_time,
              km_remaining: entry.km_remaining,
              bpc_ic: entry.bpc_ic,
              bpc_date: entry.bpc_date?.slice(0, 10),
              bpc_type: entry.bpc_type,
              sdg_depart_date: entry.sdg_depart_date?.slice(0, 10),
              sdg_depart_time: entry.sdg_depart_time,
              rl_dp: entry.rl_dp ? entry.rl_dp : null,
              load_name_loco_number: entry.load_name_loco_number,
              ind_id: entry.backloading,
              updated_by: userData.id,
            },
          })),
        };

        const updateRes = await fetch(`${urlPrefix}updateAllMasterData`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatePayload),
        });

        if (!updateRes.ok) {
          const err = await updateRes.json();
          throw new Error(err.message || "Update failed");
        }
      }

      if (insertRows.length) {
        const insertPayload = {
          table_name: "t_unloading_hdr",
          data: insertRows.map((entry) => ({
            from: entry.from,
            ldg_date: entry.ldg_date,
            to: entry.to,
            cmdt: entry.cmdt,
            act_wgn: entry.act_wgn,
            wgn_type: entry.wgn_type,
            tp_sp: entry.tp_sp,
            to_interchange: entry.to_interchange,
            to_date: entry.to_date,
            to_time: entry.to_time,
            status_remark: entry.status_remark,
            placed_date: entry.placed_date,
            placed_time: entry.placed_time,
            remarks: entry.remarks,
            released_date: entry.released_date,
            released_time: entry.released_time,
            km_remaining: entry.km_remaining,
            bpc_ic: entry.bpc_ic,
            bpc_date: entry.bpc_date,
            bpc_type: entry.bpc_type,
            sdg_depart_date: entry.sdg_depart_date,
            sdg_depart_time: entry.sdg_depart_time,
            rl_dp: entry.rl_dp ? entry.rl_dp : null,
            load_name_loco_number: entry.load_name_loco_number,
            ind_id: entry.backloading,
            created_by: userData.id,
          })),
        };
        const insertRes = await fetch(`${urlPrefix}insert/insertData`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(insertPayload),
        });

        if (!insertRes.ok) {
          const err = await insertRes.json();
          throw new Error(err.message || "Insert failed");
        }
      }
      /////////////////////////////////////////

      if (updatebklRows.length) {
        const updatebklPayload = {
          table_name: "t_indent_hdr",
          rows: updatebklRows.map((entry) => ({
            id: entry.backloading,
            updates: {
              action: "accept",
            },
          })),
        };

        const updatebklRes = await fetch(`${urlPrefix}updateAllMasterData`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatebklPayload),
        });

        /////////////////////////dd/////////////////////////

        if (updatebklRes.ok) {
          if (insertRows.length) {
            const loadingInsertPayload = {
              table_name: "t_loading_hdr",
              data: updatebklRows.map((entry) => ({
                indent_hdr_id: entry.backloading,
                bpc: `${entry.bpc_ic}-${entry.bpc_date?.slice(8, 10)}/${entry.bpc_date?.slice(5, 7)}-${entry.bpc_type}`,
                created_by: userData.id,
              })),
            };
            const loadingInsertRes = await fetch(
              `${urlPrefix}insert/insertData`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(loadingInsertPayload),
              },
            );

            if (!loadingInsertRes.ok) {
              const err = await loadingInsertRes.json();
              throw new Error(err.message || "Insert failed");
            }
          }
        }

        if (!updatebklRes.ok) {
          const err = await updatebklRes.json();
          throw new Error(err.message || "Update failed");
        }
      }

      toast.success("Saved successfully");

      fetchData();
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };
  return (
    <div className="container-fluid mt-3">
      {loading && <Loading />}

      <h4 className="bg-dark text-white p-2 text-center">CLS Indent </h4>
      <div className="d-flex justify-content-center">
        <div className="my-3">
          <input
            type="date"
            className="form-control d-inline-block"
            style={{ width: "180px", fontSize: "0.9rem" }}
            value={date}
            max={getCurrentDate()}
            onChange={(e) => setDate(e.target.value)}
          />{" "}
          <button className="btn btn-dark btn-sm" onClick={addRow}>
            Add Row
          </button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered" style={{ fontSize: "12px" }}>
          <thead className="border table-dark  ">
            <tr className="table-">
              {keys.map((key) => (
                <th key={key}>{key.replaceAll("_", " ").toUpperCase()}</th>
              ))}
            </tr>
          </thead>
          <tbody className="    ">
            {entries.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <tr
                  onClick={() => setSelectedRow(rowIndex)}
                  style={{
                    cursor: "pointer",
                    border: selectedRow === rowIndex ? "3px solid #b69bee" : "",
                  }}
                >
                  {keys.map((key) => (
                    <td key={key} className="p-1 m-0">
                      {key === "Sr No." ? (
                        <h1 class="badge text-bg-dark p-2">{rowIndex + 1}</h1>
                      ) : key === "delete" ? (
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => removeRow(rowIndex)}
                        >
                          &times;
                        </button>
                      ) : key === "rl_dp" ? (
                        <input
                          className=" form-select-sm shadow"
                          style={inputStyle}
                          type="text"
                          value={row.rl_dp || null}
                          readOnly
                        />
                      ) : key === "to_time" ||
                        key === "placed_time" ||
                        key === "released_time" ||
                        key === "sdg_depart_time" ? (
                        <input
                          type="time"
                          className=" form-select-sm shadow"
                          style={inputStyle}
                          value={row[key] ? row[key] : ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "ldg_date" ||
                        key === "to_date" ||
                        key === "placed_date" ||
                        key === "released_date" ||
                        key === "bpc_date" ||
                        key === "sdg_depart_date" ? (
                        <input
                          type="date"
                          className=" form-select-sm shadow"
                          style={inputStyle}
                          value={row[key] ? row[key]?.slice(0, 10) : null}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "act_wgn" ? (
                        <input
                          className="form-select form-select-sm shadow"
                          style={inputStyle}
                          type="number"
                          value={row[key] || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || Number(value) >= 0) {
                              handleChange(rowIndex, key, value);
                            }
                          }}
                        />
                      ) : selectOptions[key] ? (
                        <select
                          className="form-select form-select-sm shadow"
                          style={{
                            width: "110px",
                            backgroundColor: "#e1dde9",
                            color: "#5c5666",
                            border: "2px solid #fafafa",
                            borderRadius: "10px",
                            fontWeight: "500",
                            paddingRight: "2rem",
                          }}
                          value={row[key] || ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          {selectOptions[key].map((item, i) => (
                            <option key={i} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      ) : key === "backloading" ? (
                        <select
                          className="form-control"
                          style={{
                            width: "200px",
                            background: "#e1dde9",
                            color: "#5c5666",
                            border: "2px solid #fafafa",
                            borderRadius: "10px",
                            fontWeight: "500",
                            cursor: "pointer",
                            fontSize: "0.8rem",
                          }}
                          disabled={
                            !row.to ||
                            !row.bpc_ic ||
                            !row.bpc_date ||
                            !row.bpc_type
                          }
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        >
                          <option>Select </option>{" "}
                          <option disabled>
                            Id/Fcn No./ORD Date/Destination{" "}
                          </option>
                          {row.to &&
                            backload

                              .filter((item) => item.siding === row.to)
                              .map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.id}/{item.fcn_no}/
                                  {item.order_date?.slice(0, 10)}/
                                  {item.destination}
                                </option>
                              ))}
                        </select>
                      ) : (
                        <input
                          type="text"
                          className="form-select form-select-sm shadow"
                          style={inputStyle}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      )}
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center">
        <button className="btn btn-success" onClick={handleSubmit}>
          Save
        </button>
      </div>
    </div>
  );
};

export default ClsUnloadingIns;
